import { render, staticRenderFns } from "./CamaraDashboardPantalla.vue?vue&type=template&id=0d40aad4&"
import script from "./CamaraDashboardPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraDashboardPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0d40aad4', component.options)
    } else {
      api.reload('0d40aad4', component.options)
    }
    module.hot.accept("./CamaraDashboardPantalla.vue?vue&type=template&id=0d40aad4&", function () {
      api.rerender('0d40aad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Dashboard/CamaraDashboardPantalla.vue"
export default component.exports